import { render, staticRenderFns } from "./SignDegree.vue?vue&type=template&id=533c44b2&"
import script from "./SignDegree.vue?vue&type=script&lang=ts&"
export * from "./SignDegree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports